import styles from "./SobreMim.module.css";

import PostModelo from "componentes/PostModelo";
import fotoCapa from "assets/sobre_mim_capa.png";
import fotoSobreMim from "assets/sobre_mim_foto.jpg";

export default function SobreMim() {
    return (
        <PostModelo
            fotoCapa={fotoCapa}
            titulo="Sobre mim"
        >
            <h3 className={styles.subtitulo}>
                Olá, eu sou o Renan!
            </h3>

            <img
                src={fotoSobreMim}
                alt="Foto do Antônio Evaldo sorrindo"
                className={styles.fotoSobreMim}
            />
            
            <p className={styles.paragrafo}>
                <ul>
                    <li>
            • Desenvolvimento e correção de bugs para sistemas web usando as tecnologias abaixo:

                    </li>
                    <li>
• Javascript | React VueJS | Node | HTML | CSS | jQuery | Bootstrap 4 | Webpack | Gulp | Banco de Dados.

                    </li>
                    <li>
• Base sólida de Javascript com os novos recursos da linguagem
                        
                    </li>
                    <li>
• Funções, Objetos, Array, Prototype, Clousure.
                        
                    </li>
                    <li>
• Usar JS para interagir com o DOM, requisições Ajax, ferramentas de build (Webpack e Gulp).

                    </li>
                    <li>
• Paradigmas de programação aplicados em JS.

                    </li>
                    <li>
• CSS com Flexbox

                    </li>
                    <li>

• Consumo de APIS 
                    </li>
                    <li>
• Persistência de Dados 

                    </li>
                    <li>

• Deploy final de arquivos estáticos; WebPack
                    </li>
                    <li>

• Análise e Desenvolvimento de Sistemas 
                    </li>
                    <li>
• Graduação em Logística Empresarial;

                    </li>
                    <li>

• Pós-graduação em Administração Geral;
                    </li>
                    <li>

• Experiência como Pesquisador, Assistente/auxiliar administrativo, digitador;
                    </li>
                    <li>
• Atuei nas Áreas de Pesquisas em Geral (Localização, Preços, Mídias e política), Bancos e Financeiras, Transporte e Logística (importação e exportação de cargas aéreas e rodoviárias).
                    </li>
                </ul>
            </p>

        </PostModelo>
    )
}